import React, { useMemo } from 'react';
import cx from 'classnames';
import { SectionTreeNodeDataProps } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { backgroundInlineStyles } from './backgroundInlineStyles';
import { transformToContainerQueries } from '../utils/transformBreakpointClasses';

type SectionProps = {
  id: string;
  children?: React.ReactNode;
  editorClassName?: string;
  staticAssetsBaseURL?: string | null;
  isEditor?: boolean;
} & SectionTreeNodeDataProps &
  React.ComponentPropsWithRef<React.ElementType>;

function SectionInner(
  {
    id,
    as,
    className,
    editorClassName,
    children,
    backgroundSrc,
    staticAssetsBaseURL,
    isEditor = false,
    ...props
  }: SectionProps,
  ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
) {
  const style = useMemo(
    () => backgroundInlineStyles(backgroundSrc, staticAssetsBaseURL),
    [backgroundSrc, staticAssetsBaseURL],
  );

  return (
    <section
      id={id}
      ref={ref}
      className={cx(transformToContainerQueries(className, { isEditor }), editorClassName)}
      {...props}
      style={style}
    >
      {children}
    </section>
  );
}

SectionInner.displayName = 'Section';

export const Section = React.forwardRef<React.ComponentPropsWithRef<React.ElementType>['ref'], SectionProps>(
  SectionInner,
);
